import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

interface ContactSalesCardProps {
  onContact: () => void;
}

export const ContactSalesCard = ({ onContact }: ContactSalesCardProps) => {
  return (
    <Card className="p-6 text-center">
      <h3 className="text-xl font-semibold mb-4">Need a Custom Plan?</h3>
      <p className="text-muted-foreground mb-4">
        Contact us to create a plan that fits your specific needs
      </p>
      <Button 
        variant="outline" 
        onClick={onContact}
      >
        Contact Sales
      </Button>
    </Card>
  );
};